<template>
    <img :class="{click: img.isLink}" :src="img.url" @click="goLink"/>
</template>

<style scoped>
.click{
    cursor: pointer;
}
</style>

<script>
export default {
    props: {
        img: Object
    },
    methods: {
        goLink(){
            if(this.img.isLink){
                window.open(this.img.link)
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/img-link.vue